import { Faqs } from './Faqs';

export type { TypeFaqsProps } from './types';
export default Faqs;
